module.exports = __webpack_public_path__ + "img/icon_folder_selected_on.9d8cb936.svg";